<template>
	<div class="joint_manage_list bg-white">
		<InvitePatient ref="invitePatient" />

		<div class="item">
			<div class="item_list" v-if="list.length">
				<template v-for="item in list">
					<base-list-item
						class="base-list-item"
						:key="item.id"
						:type="curPatient.id === item.id ? 'primary' : ''"
						:value="curPatient.id === item.id"
						:user-name="item.name"
						:gender="$status.gender[item.gender]"
						:age="item.age"
						:tag="$status.relation[item.relation]"
						:phoneList="item.phoneList"
						@click="curPatient = item"
					/>
					<div class="item_title" v-if="item.phoneList.length" :key="`phone_${ item.id }`">
						<span>已绑定：{{ item.phoneList | phoneListFilter }}</span>
					</div>
				</template>
			</div>
		</div>
		<div class="toast_item">
			<div class="toast_item_title">
				<img @click="openDialogMsg" class="icon" src="@/assets/icon/icon_wait.png" />
				<span>绑定说明</span>
			</div>
			<div>
				绑定其他家属共管患者档案后，共管账号可查看、更改、 记录患者档案内容，同时可为该患者使用档案下已购买的
				服务项目，请仔细确认共管账号身份，谨慎操作。
			</div>
		</div>
		<foot-button>
			<van-button type="primary" block @click="clickShowCode">邀请绑定</van-button>
		</foot-button>
	</div>
</template>

<script>
import InvitePatient from './components/invite-patient.vue'
export default {
    name: 'joint-manage-list',
    components: { InvitePatient },
    data: () => ({
        loading: false,
        curPatient: '',
        list: []
    }),
    filters: {
        phoneListFilter (val = []) {
            return val.join('、')
        }
    },
    created () {
        this.checkDialogMsg()
    },
    mounted () {
        this.getPatientList()
    },
    methods: {
        // 检测是否默认弹出家属绑定弹窗
        checkDialogMsg () {
            const data = window.localStorage.getItem('jointManageDialogMsg')
            if (!data) {
                this.openDialogMsg()
                window.localStorage.setItem('jointManageDialogMsg', '1')
            }
        },
        openDialogMsg () {
            this.$dialog.alert({
                title: '家属绑定说明',
                message: '绑定其他家属共管患者档案后，共管账号可查看、更改、记录患者档案内容，同时可为该患者使用档案下已购买的服务项目，请仔细确认共管账号身份，谨慎操作',
                confirmButtonText: '我知道了'
            })
        },
        getPatientList () {
            this.loading = true
            this.$api.patient.getPatientList({
                source: 1
            }).then(res => {
                this.loading = false
                if (!res.code) {
                    this.list = res.data
                    this.curPatient = res.data[0]
                }
            }).catch(() => this.loading = false)
        },
        clickShowCode () {
            this.$refs.invitePatient.init(this.curPatient)
        }
    }
};
</script>

<style scoped lang="less">
.joint_manage_list {
	min-height: calc(100vh - 216px);
	padding: 0 40px;
	.item {
		.item_title {
			display: flex;
			align-items: center;
			padding: 28px 0;
			.icon {
				width: 30px;
				height: 30px;
				vertical-align: middle;
				margin-right: 7px;
			}
			font-family: PingFang SC Bold;
			font-size: 26px;
			font-weight: normal;
			word-break: break-all;
			color: @gray-9;
		}
		.item_list {
			padding-top: 40px;
			.base-list-item + .base-list-item {
				margin-top: 40px;
			}
		}
	}
}
.toast_item {
	background-color: #f5f6f7;
	border-radius: 20px;
	font-size: 24px;
	color: #8f959e;
	padding: 32px;
	margin-top: 100px;
	&_title {
		font-size: 26px;
		color: @gray-9;
		font-weight: bold;
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		img {
			width: 30px;
			height: 30px;
			margin-right: 7px;
		}
	}
}
</style>
